import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.p`
  color: ${props => props.theme.textSemiDark};
  font-family: 'Galano Classic';
  font-size: 32px;
  font-weight: 400;
  white-space: nowrap;
  padding: 0;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  ${media.medium`
    font-size: 3vw;
  `}
`;
